import { render, staticRenderFns } from "./section-blood-oxygen.vue?vue&type=template&id=7f1f4bb2&scoped=true"
import script from "./section-blood-oxygen.vue?vue&type=script&lang=js"
export * from "./section-blood-oxygen.vue?vue&type=script&lang=js"
import style0 from "./section-blood-oxygen.vue?vue&type=style&index=0&id=7f1f4bb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1f4bb2",
  null
  
)

export default component.exports